import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const SplitSupply = {
  Content: lazy(
    () =>
      import(
        'components/direct-sales/split-supply/components/SplitSupplyContent'
      )
  ),
  Template: lazy(() => import('components/app/routes/NonRevampScreenTemplate'))
};

export default SplitSupply;
